// Mirror of remedy-credit/lib/card-topup-fee.ts — สูตรต้องตรงกันเป๊ะ.
// Display-only: server (credit) เป็นคนคิด fee จริงตอนสร้าง charge.
export interface CardFeeResult {
  fee: number
  chargeTotal: number
}

export function computeCardFee(
  amount: number,
  cfg: { rate: number; threshold: number }
): CardFeeResult {
  const rate = Number.isFinite(cfg.rate) && cfg.rate > 0 ? Math.min(cfg.rate, 10) : 0
  const threshold =
    Number.isFinite(cfg.threshold) && cfg.threshold > 0 ? cfg.threshold : 0
  const amt = Number.isFinite(amount) && amount > 0 ? Math.floor(amount) : 0
  const fee =
    rate > 0 && amt > 0 && amt < threshold ? Math.ceil((amt * rate) / 100) : 0
  return { fee, chargeTotal: amt + fee }
}
